<app-modal
  [title]="'Show search' | trans:'shows/search-show-modal/header/title'"
  maxWidth="900px"
  width="100%"
>
  <ng-template>
    <div class="d-flex gap-16 flex-direction-column">
      <div>
        <div class="d-flex gap-16">
          <div class="d-flex flex-direction-column">
            <label class="t4 fw-medium text-uppercase m-b-8">
              {{ 'From' | trans:'shows/search-show-modal/date-range/from.Label' }}
            </label>
              <app-datepicker
                [isPickerOpened]="isFromDatepickerOpened()"
                outputType="dayjs"
                [min]="today"
                [ngModel]="dateFrom()"
                (ngModelChange)="dateFrom.set($event); isFromDatepickerOpened.set(false);"
              />
          </div>

          <div class="d-flex flex-direction-column">
            <label class="t4 fw-medium text-uppercase m-b-8">
              {{ 'To' | trans:'shows/search-show-modal/date-range/to.Label' }}
            </label>
              <app-datepicker
                [isPickerOpened]="isToDatepickerOpened()"
                outputType="dayjs"
                [min]="today"
                [ngModel]="dateTo()"
                (ngModelChange)="dateTo.set($event); isToDatepickerOpened.set(false);"
              />
          </div>
        </div>
      </div>

      <div>
        <p class="t4 fw-medium text-uppercase m-b-8">
          {{ 'Auditorium' | trans:'shows/search-show-modal/auditorium.Title' }}
        </p>

        <div class="d-flex gap-16 flex-wrap">
          @for (auditorium of showsStore.auditoriums(); track auditorium.id) {
            <app-chip
              [value]="auditorium.id"
              [selected]="selectedAuditoriumIds().includes(auditorium.id)"
              [disabled]="!selectedAuditoriumIds().includes(auditorium.id)"
              [label]="auditorium.name"
              (onClick)="toggleAuditorium(auditorium.id)"
            />
          }
        </div>
      </div>

      <div>
        <p class="t4 fw-medium text-uppercase m-b-8">
          {{ 'Show' | trans:'shows/search-show-modal/show.Title' }}
        </p>
        <app-form-control>
          <input
            type="text"
            class="input"
            [(ngModel)]="movieSearchTerm"
            [placeholder]="'Search for a show' | trans:'shows/search-show-modal/movie.Placeholder'"
            (keydown.enter)="performSearch()"
          />
        </app-form-control>
      </div>

        <div class="m-t-16">
          <p class="t4 fw-medium text-uppercase m-b-12">
            {{ 'Results' | trans:'shows/search-show-modal/results.Title' }}
          </p>

          @if (shows.length > 0) {
            <table class="base full-width table-layout-fixed">
              <thead>
              <tr>
                <th width="35%">
                  {{ 'Show' | trans:'shows/search-show-modal/table/movie.Text' }}
                </th>
                <th width="25%">
                  {{ 'Start date' | trans:'shows/search-show-modal/table/startDate.Text' }}
                </th>
                <th width="20%">
                  {{ 'Auditorium' | trans:'shows/search-show-modal/table/auditorium.Text' }}
                </th>
              </tr>
              </thead>
              <tbody>
                @for (show of shows; track show.id) {
                  <tr
                    class="show-row cursor-pointer"
                    (click)="navigateToShow(show.id)"
                  >
                    <td>
                      <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                        {{ show.title }}
                      </div>
                    </td>
                    <td>
                      <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                        {{ show.beginning | localeDatetimeFormat }}
                      </div>
                    </td>
                    <td>
                      <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                        {{ show.auditoriumName }}
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p>{{ 'No shows found.' | trans:'shows/search-show-modal/noShowsFound.Text' }}</p>
          }
        </div>
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
        type="button"
      >
        {{ 'Close' | trans:'shows/search-show-modal/close.Button' }}
      </button>

      <button
        [class.loading]="isLoading()"
        [disabled]="isLoading()"
        class="button button--md button--primary text-uppercase"
        (click)="performSearch()"
        type="button"
      >
        {{ 'Search' | trans:'shows/search-show-modal/search.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

